const carsForFilter = {
	dodge: {
		'ram-truck-cummins': {
			1996: ['5.9L'],
			1997: ['5.9L'],
			1998: ['5.9L'],
			1999: ['5.9L'],
			2000: ['5.9L'],
			2001: ['5.9L'],
			2002: ['5.9L'],
			2003: ['5.9L'],
			2004: ['5.9L'],
			2005: ['5.9L'],
			2006: ['5.9L'],
			2007: ['5.9L', '6.7L'],
			2008: ['6.7L'],
			2009: ['6.7L'],
			2010: ['6.7L'],
			2011: ['6.7L'],
			2012: ['6.7L'],
			// new addition (2024-06-05)
			2013: ['6.7L'],
			2014: ['6.7L'],
			2015: ['6.7L'],
			2016: ['6.7L'],
			2017: ['6.7L'],
		},
	},
};
